import { render, staticRenderFns } from "./lt-similar-expand.vue?vue&type=template&id=7c27679a&scoped=true&"
import script from "./lt-similar-expand.vue?vue&type=script&lang=js&"
export * from "./lt-similar-expand.vue?vue&type=script&lang=js&"
import style0 from "./lt-similar-expand.vue?vue&type=style&index=0&id=7c27679a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c27679a",
  null
  
)

export default component.exports